import { Modal, notification } from 'antd';
import styles from './index.module.sass';
import { ButtonMain } from '@/modules/common/components/button';
import { useNavigate } from 'react-router-dom';
import { $topRecipesForWarehouse } from '@/widgets/recipe/model';
import { useStore } from 'effector-react';
import { setSelectedMix } from '@/modules/mixing/store/recipes.store';

export const MixingModal = ({
  visible,
  setVisible,
  setDisplaySelectBunker,
  selectedRecipe,
}: {
  visible: boolean;
  setVisible: (val: boolean) => void;
  setDisplaySelectBunker: (val: boolean) => void;
  selectedRecipe: number;
}) => {
  const topRecipes = useStore($topRecipesForWarehouse);
  const selectedRecipeData =
    selectedRecipe !== -1
      ? topRecipes?.mixes.find((item) => item.id === selectedRecipe)
      : null;
  const navigate = useNavigate();
  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      width={634}
      centered
      footer={
        <div className={styles.footerModal}>
          <ButtonMain
            className={styles.actionBtn}
            label="замиксовать в миксере"
            onClick={() => {
              if (!selectedRecipeData)
                return notification.error({
                  message: 'Возникла непредвиденная ошибка. Некорректный микс',
                });
              setSelectedMix(selectedRecipeData);
              (selectedRecipeData?.id ||
                (selectedRecipeData?.id === 0)) &&
                  navigate(`/mixing/mixer/${selectedRecipeData.id}`);
            }}
          />
          <ButtonMain
            className={styles.actionBtn}
            //active={PUBLIC_MODE === 'development'}
            label="замиксовать в бункере"
            onClick={() => {
              setVisible(false);
              setDisplaySelectBunker(true);
            }}
          />
        </div>
      }
    >
      <div className={styles.root}>
        <span>выбор способа миксования</span>
        <p className={styles.text}>
          Вы можете произвести миксование согласно рецепта с использованием двух
          технологий миксования:
        </p>
        <ol>
          <li>В производственном миксере, в пункте приема зерна.</li>
          <li>
            В Бункере-перегрузчике Liliani на вашем складе, согласно выбранной модели и
            конфигурации (
            <a
              className=""
              target={'_blank'}
              href="https://test.cnf.liliani.ru/configurator"
            >
              открыть конфигуратор
            </a>
            )
          </li>
        </ol>
      </div>
    </Modal>
  );
};
